<template>
  <div>
    <el-select
      v-model="myvalue"
      filterable
      clearable
      :disabled="disabled ? true : false"
      :placeholder="placeholder"
      @change="($event) => $emit('input', $event)"
    >
      <el-option
        v-for="item in dataList"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>
  
  <script>
export default {
  props: {
    value: [String, Number],
    placeholder: {
      default: "请选择公司",
    },
    type:  {
      default: "0",
    },
    dataUrl: {
      default: "/sys/tscheduledetail/getCompanyList",
    },
    disabled: {
      default: false,
    },
    name:{
      default: "0",
    },
  },
  data() {
    return {
      myvalue: this.value,
      dataList: [],
    };
  },
  created() {
    this.getDataList();
  },
  watch: {
    value(val) {
      this.myvalue = val;
    },
  },
  methods: {
    async getDataList() {
      this.$http[this.type === '1' ? 'post' : 'get']
        (this.dataUrl)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataList = [];
          if (res.data != null) {
           
            if (this.dataUrl == "/sys/companies/list") {
              res.data
                .filter((item) => item?.standard == 1)
                .forEach((element) => {
                  this.dataList.push({
                    label: element.name,
                    value: element.id,
                  });
                });
            } else {
              res.data.forEach((element) => {
                this.dataList.push({ label:  element.name, value: this.name == 'name' ? element.name : element.id });
              });
            }
          }
        })
        .catch(() => {});
    },
  },
};
</script>
  
  <style>
</style>